import React, { Component } from 'react';
import Modal from 'react-modal';
import ToggleDisplay from 'react-toggle-display';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import moment from 'moment';
import '../../../../../src/assets/css/react-table.css'
import { BeatLoader } from 'react-spinners';
import 'react-tabs/style/react-tabs.css';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import NotificationSystem from 'react-notification-system';
import { orderedMenu, menuItems } from './mockData/mockData.js';
import OrdersReport from './Orders/ordersReport.jsx';
import AuditReport from '../auditReportComponents/auditReport';
import $ from 'jquery';
import { get } from '../../../../server/actions'
import {showFile, _addNotification, _addNotificationError} from "../../../../server/util";
import CatererReport from './CatererReport/catererReport';
import {getGradeNumberByText, getSchoolGrades, groupBy} from '../../../../server/util'
import {getReportMenuOptions} from '../../../Misc/MenuOptions/menuOptionsActions';
import OrderCost from './Orders/orderCost';
let download = require('downloadjs');
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class AdminReports extends Component {
    constructor() {
        super()
        this.state = {
            loading: false,
            filterBy: "Weekly",
            viewBy: "Day",
            week: "",
            month: "",            
            otherReports: "",
            showOptions: true,
            eligTypes: [],
            openCatererModal: false,
            catererEmail: "",
            toogle: true,
            startDate:moment().startOf('day'),
            endDate:moment().endOf('day'),
            date:moment(),
            allergiesReportResponse: [],
            lunchEligibilityReportResponse: [],
            orderStudentWithMeal: [],
            catererResponse: [],
            orderResponse:'',
            mealType:(getReportMenuOptions()[0]||'')

        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
    }
    changeWeek = (action) => {
        switch (action) {
            case 'next': {
                let date = moment(this.state.date).endOf('Week').add(1, 'days');
                let from_date = date.startOf('Week').format('MM/DD');
                let to_date = date.endOf('Week').format('MM/DD');
                console.log({ from_date: from_date, to_date: to_date });
                this.setState({ week: from_date + " - " + to_date, date: new Date(date) });
                break;
            }
            case 'prev': {
                let date = moment(this.state.date).startOf('Week').subtract(1, 'days');
                let from_date = date.startOf('Week').format('MM/DD');
                let to_date = date.endOf('Week').format('MM/DD');
                console.log({ from_date: from_date, to_date: to_date });
                this.setState({ week: from_date + " - " + to_date, date: new Date(date) });
                break;
            }
        }

    }

    changeMonth = (action) => {
        switch (action) {
            case 'next': {
                let nextMonth = moment(this.state.date).add(1, 'months');
                this.setState({ month: nextMonth.format('MMMM YYYY'), date: new Date(nextMonth) });
                break;
            }
            case 'prev': {
                let prevMonth = moment(this.state.date).subtract(1, 'months');
                this.setState({ month: prevMonth.format('MMMM YYYY'), date: new Date(prevMonth) });
                break;
            }
        }

    }
    setDay = () => {
        this.setState({
        date:moment(),
        startDate:moment().startOf('day'),
        endDate:moment().endOf('day'),
        toogle: !this.state.toogle,
     },()=>{
         this.getSchoolMealReport(moment().startOf('day'),moment().endOf('day'));
     });
    }
    setWeek = () => {
        const from_date = moment().startOf('Week');
        const to_date = moment().endOf('Week');
        this.setState({ week: from_date.format('MM/DD') + " - " + to_date.format('MM/DD'), 
        date: from_date,
        startDate:from_date,
        endDate:to_date,
        toogle: !this.state.toogle,
     },()=>{
         this.getSchoolMealReport(from_date,to_date);
     });
    }
    componentWillMount = () => {
        //this.getSchoolMealReport()
    };
    componentDidMount=()=>{
        //this.setDay();
        //this.setWeek()
    }
    getSchoolMealReport = (startDate, endDate) => {
        this.setState({loading: true});
        get(`/reports/schoolMealReport?isVersion2=true&mealSchoolId=${sessionStorage.getItem('SchoolId')}&startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}&menuType=${this.state.mealType}&isOrder=true&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ orderStudentWithMeal: data.studentWithMeal,orderResponse:data.startDate, loading:false })
        }).catch(error => {
            this.setState({loading: false});
            console.log("Loading Report Failed", error)
        })
    }
    getAllergiesReport = () => {
        this.setState({loading: true});
        get(`/reports/allergiesReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=AllData&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ allergiesReportResponse: data.response, loading:false })
        }).catch(error => {
            this.setState({loading: false});
            console.log("Loading Report Failed", error)
        })
    };
    getAllergiesReportPdf = () => {
        this.setState({loading: true});
        get(`/reports/allergiesReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=Pdf&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({loading: false});
            return response.blob();
        }).then(blob => {
            let filename = "Allergies Reports for ";
    
                   showFile(blob,filename);
            
        }).catch(error => {
            this.setState({loading: false});
            console.log("Download Failed", error)
        })
    };
    getLunchEligibilityReports = () => {
        this.setState({loading: true});
        const eligTypeParam = this.state.eligTypes.length > 0
            ? '&' + this.state.eligTypes.map(t => `eligType=${encodeURIComponent(t)}`).join('&')
            : '';
        get(`/reports/fmActualReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=AllData&schoolYear=${sessionStorage.getItem('schoolYearValue')}${eligTypeParam}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ lunchEligibilityReportResponse: data.response, loading:false })
        }).catch(error => {
            this.setState({loading: false});
            console.log("Loading Report Failed", error)
        })
    };
    handleEligTypeChange = (type) => {
        const current = this.state.eligTypes;
        const updated = current.includes(type)
            ? current.filter(t => t !== type)
            : [...current, type];
        this.setState({ eligTypes: updated }, () => {
            this.getLunchEligibilityReports();
        });
    };
    getLunchEligibilityReportsPdf = () => {
        this.setState({loading: true});
        get( `/reports/fmActualReport?mealSchoolId=${sessionStorage.getItem('SchoolId')}&fileType=Pdf&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({loading: false});
            return response.blob();
        }).then(blob => {
            let filename = "Lunch Eligibility Reports for ";
                   showFile(blob,filename);
        }).catch(error => {
            this.setState({loading: false});
            console.log("Download Failed", error)
        })
    };

    render() {
        const gradeGroup=groupBy(getSchoolGrades(0,false),'value');
        const { viewBy, filterBy, loading, week, month, date, otherReports, showOptions,openCatererModal } = this.state;
        console.log('state', this.state);
        {
            $('#filteredBy button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
                // TODO: insert whatever you want to do with $(this) here
            })
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />                
                <section className=" full-width clearfix">
                    <div className='sweet-loading'
                        style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2 style={{ marginLeft: '15px' }}>
                                <span>Admin Reports</span>
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="tabCommon custom-tabCommon">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li role="presentation" className="active"><a style={{ padding: '0px 10px' }} href="#Sec1" id="#orders"
                                            aria-controls="home"
                                            role="tab" data-toggle="tab" onClick={() => { this.getSchoolMealReport() }}>Orders</a>
                                        </li>
                                        <li role="presentation">
                                            <a style={{ padding: '0px 10px' }} href="#Sec2" aria-controls="profile" id="#costRate"
                                                role="tab" onClick={() => { }}
                                                data-toggle="tab">Orders Cost Report</a></li>
                                        <li role="presentation"><a style={{ padding: '0px 10px' }} href="#Sec3" aria-controls="profile" role="tab" id="#caterer"
                                            data-toggle="tab" >Caterer</a></li>
                                        <li role="presentation"><a style={{ padding: '0px 10px' }} href="#Sec4" aria-controls="profile" id="#audit" role="tab" onClick={() => {
                                        }}
                                            data-toggle="tab">Audit Reports</a></li>
                                        <li role="presentation">
                                            <a style={{ padding: '0px 10px' }} href="#Sec5" aria-controls="profile" id="#other"
                                                role="tab" onClick={() => { }}
                                                data-toggle="tab">Others</a></li>
                                    </ul>
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane active" id="Sec1">
                                            <OrdersReport />
                                        </div>
                                        <div role="tabpanel" className="tab-pane" id="Sec2">
                                            <OrderCost />
                                        </div>
                                        <div role="tabpanel" className="tab-pane" id="Sec3">
                                            <div style={{ display: 'inline-block', backgroundColor: 'white', margin: '5px', float: 'right', borderRadius: '3px' }}>
                                                <a style={{ fontSize: '22px', margin: '5px 20px 5px 20px' }} title="Click to Send Report"
                                                    onClick={() => {
                                                        this.refs.refCaterer.openCatererModal();
                                                    }}

                                                    target='_blank'
                                                    className="fa fa-share-square-o QuickReports-PDF"><i /></a>
                                                <a style={{ fontSize: '22px', margin: '5px 20px 5px 20px' }} title="Click to Download PDF"
                                                    onClick={() => {
                                                        this.refs.refCaterer.getCatererReportPdf('Pdf');
                                                        }}

                                                    target='_blank'
                                                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a></div>
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title">Caterer</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <CatererReport ref="refCaterer" />
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel" className="tab-pane" id="Sec4">
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title">Audit Reports</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <AuditReport />
                                                </div>
                                            </div>
                                        </div>
                                        <div role="tabpanel" className="tab-pane" id="Sec5">
                                            {!showOptions && <div style={{ display: 'inline-block', backgroundColor: 'white', margin: '5px', float: 'right', borderRadius: '3px' }}>
                                                <a style={{ fontSize: '22px', margin: '5px' }} title="Click to Download PDF"
                                                    onClick={() => {  
                                                        if (otherReports == 'Allergies') { this.getAllergiesReportPdf() }
                                                        if (otherReports == 'Eligibility') { this.getLunchEligibilityReportsPdf() }
                                                    }}
                                                    target='_blank'
                                                    className="fa fa-file-pdf-o fa-2x QuickReports-PDF">
                                                    <i /></a></div>}
                                            <div className="panel panel-p1 panel-primary">
                                                <div className="panel-heading text-center">
                                                    <h3 className="panel-title">Other</h3>
                                                </div>
                                                <div className="panel-body">
                                                    {showOptions ? <div className="row">
                                                        <div className="col-xs-6 col-sm-6" style={{ textAlign: 'center' }}>
                                                            <button className="outline-warning-btn btn btn-outline-warning" onClick={() => {
                                                                this.getAllergiesReport(),
                                                                this.setState({ otherReports: 'Allergies', showOptions: false });
                                                            }} >
                                                                {/* <input type="checkbox" id="inlineCheckbox1" checked={false} /> */}
                                                                <i className="fa fa-bug outline-fa" aria-hidden="true"></i>
                                                                Allergies 
                                                            </button>
                                                        </div>
                                                        <div className="col-xs-6 col-sm-6" style={{ textAlign: 'center' }}>
                                                            <button className="outline-warning-btn btn btn-outline-warning" onClick={() => {
                                                                this.getLunchEligibilityReports(),
                                                                this.setState({ otherReports: 'Eligibility', showOptions: false });
                                                            }}>
                                                                {/* <input type="checkbox" id="inlineCheckbox1" checked={false} /> */}
                                                                <i className="fa fa-flag-o outline-fa" aria-hidden="true"></i>
                                                                 Lunch Eligibility Report 
                                                            </button>
                                                        </div>
                                                    </div> : <div>
                                                            <div className="row">
                                                                <div className="col-sm-6 col-xs-6">
                                                                    <label style={{ marginLeft: '20px' }}>{otherReports == 'Allergies' ? 'Allergy Reports For All Grades' : 'Lunch Eligibility Report'}</label>
                                                                </div>
                                                                <div className="col-sm-6 col-xs-6">
                                                                    {otherReports != 'Allergies' && <div style={{ display: 'inline-flex' }}><label style={{ margin: '5px' }}> Type: </label>
                                                                        <div>
                                                                            {['Free', 'Reduced', 'Regular'].map(type => (
                                                                                <label key={type} style={{ marginRight: '10px', fontWeight: 'normal', cursor: 'pointer' }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        value={type}
                                                                                        checked={this.state.eligTypes.includes(type)}
                                                                                        onChange={() => this.handleEligTypeChange(type)}
                                                                                        style={{ marginRight: '4px' }}
                                                                                    />
                                                                                    {type}
                                                                                </label>
                                                                            ))}
                                                                        </div>
                                                                    </div>}
                                                                    <button class="pull-right btn bg-color-4" onClick={() => { this.setState({ showOptions: true }) }} style={{ margin: '0px 10px 10px 0px', color: "white" }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                                                                </div>
                                                            </div>
                                                            {otherReports == 'Allergies' && <div className="row"><ReactTable style={{ textAlign: 'center' }}
                                                                data={this.state.allergiesReportResponse}
                                                                columns={[{ Header: "Student", style: { width: '100%' }, Cell: props => <span>{props.original.stdLName + ' ' + props.original.stdFName}</span> },
                                                                { Header: "Grade",style: { textAlign: 'center', textTransform:'capitalize' }, Cell:(props)=>{
                                                                    return <span>{((gradeGroup[props.original.grade]||[])[0]||{}).label||''}</span>        
                                                                }},
                                                                { Header: "Teacher", accessor: "teacherName" },
                                                        { Header: "Allergic To", accessor: "allergies", }]}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                            /> </div>}
                                                            {otherReports == 'Eligibility' && <div className="row"><ReactTable style={{ textAlign: 'center' }}
                                                                data={this.state.lunchEligibilityReportResponse}
                                                                columns={[{ Header: "StudentId", style: { width: '100%' }, accessor: "studentId" },
                                                                { Header: "Student", Cell: props => <span>{props.original.studentLName + ' ' + props.original.studentFName}</span> },
                                                                { Header: "Grade", style: { textAlign: 'center', textTransform:'capitalize' },Cell:(props)=>{
                                                                    return <span>{
                                                                        ((gradeGroup[props.original.gradeName]||[])[0]||{}).label||''}</span>        
                                                                }},
                                                                { Header: "Teacher",accessor: "teacherName" },
                                                                { Header: "Eligibility",Cell: props =><span>{(props.original.freeMeal || '') === true ? 'FreeMeals' : 'ReducedPrice'}</span> }]}
                                                                defaultPageSize={10}
                                                                className="-striped -highlight"
                                                                noDataText='No data found'
                                                            /></div>}
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default AdminReports;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/AdminReports/AdminReports.jsx